export const UPDATE_TAGS_POOL = '@project/UPDATE_TAGS_POOL';
